'use strict';/* global define */define('modules/integrations/services/integrations/index',['require','exports','module'],function(require,exports,module){'use strict';/**
   * Return the ngResource object
   * for the integrations service
   */// @ngInject
     factory.$inject = ["$resource", "API_ENDPOINT", "_"];
function factory($resource,API_ENDPOINT,_){// jshint validthis:true
// jshint latedef:false
var Integrations=$resource(API_ENDPOINT+'integrations/:id',{id:'@id'},{update:{method:'PATCH'},create:{method:'POST'}});var integrationEnabled=$resource(API_ENDPOINT+'integrations/:name/enabled',{name:'@name'});var slack=$resource(API_ENDPOINT+'integrations/slack/test',null,{test:{method:'POST'}});return{get:Integrations.get,query:Integrations.query,update:Integrations.update,create:Integrations.create,delete:Integrations.delete,getEnabledIntegration:integrationEnabled.get,sendSlackTestMessage:slack.test,getIntegratedNames:getIntegratedNames,getByConfigId:getByConfigId};// ---
/**
     * Helper function to get all integrated service names
     *
     * @param  {Array} integrations - Integrated services
     * @return {Array}              - Collection of integrated service names
     */function getIntegratedNames(integrations){return integrations.map(function(integration){return integration.name;});}/**
     * Get integration information by the configturation id
     *
     * @param  {Array}  integrations        - Collection of available integraitons
     * @param  {String} integrationConfigId - Integration config id e.g. `bamboohr`
     *
     * @return {Object}                     - Integration object
     */function getByConfigId(integrations,integrationConfigId){return _.find(integrations,function(integration){return integration.name===integrationConfigId;});}}module.exports=factory;});
